import type { TrackModel } from "../../models/models";
import { AUDIO_TYPE, COLLECTION_IDS } from "../../models/dictionary";

export const soundscapeTracks: TrackModel[] = [
	{
		id: "080a48a8-31eb-46e6-a8a4-e86b217ed065",
		audioUrlStub: "https://audios.coffitivity.com/ocean-waves",
		slug: "ocean-waves",
		name: "Ocean Waves",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		isLooping: true,
		description:
			"The rhythmic ebb and flow of the sea clears the mind and soothes the soul.",
		imageUrlStub: "https://images.coffitivity.com/ocean-waves",
		albumId: "443950e8-634e-4406-ae2e-2b0d2d4c147f",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:relaxation", "effects:creativity", "effects:sleep"],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:38+00",
	},
	{
		id: "4cebff8d-6b59-4d03-b8a0-7f72b2378266",
		audioUrlStub: "https://audios.coffitivity.com/waterfall",
		slug: "waterfall",
		name: "Waterfall",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		isLooping: true,
		description:
			"A powerful cascade of water drowns out distraction and nourishes focus.",
		imageUrlStub: "https://images.coffitivity.com/waterfall",
		albumId: "443950e8-634e-4406-ae2e-2b0d2d4c147f",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:focus", "effects:energy", "effects:productivity"],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:39+00",
	},
	{
		id: "7c383061-2364-4b89-a83f-3e7d176cda4a",
		audioUrlStub: "https://audios.coffitivity.com/heavy-rain-storm",
		slug: "heavy-rain-storm",
		name: "Heavy Rain Storm",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		isLooping: true,
		description:
			"A deep downpour envelops you—a calming cocoon of white noise and natural sound.",
		imageUrlStub: "https://images.coffitivity.com/heavy-rain-storm",
		albumId: "443950e8-634e-4406-ae2e-2b0d2d4c147f",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:relaxation", "effects:focus", "effects:sleep"],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:40+00",
	},
	{
		id: "66f34f55-9f9d-46a9-8a80-ad269a35b7bb",
		audioUrlStub: "https://audios.coffitivity.com/thunderstorm",
		slug: "thunderstorm",
		name: "Thunderstorm",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		isLooping: true,
		description:
			"Feel the drama and depth of rolling thunder and falling rain—ideal for intense focus or quiet awe.",
		imageUrlStub: "https://images.coffitivity.com/thunderstorm",
		albumId: "443950e8-634e-4406-ae2e-2b0d2d4c147f",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: [
			"effects:relaxation",
			"effects:stimulation",
			"effects:creativity",
		],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:41+00",
	},
	{
		id: "c3085065-43f6-4cef-a192-4dc5701fd672",
		audioUrlStub: "https://audios.coffitivity.com/bird-songs",
		slug: "bird-songs",
		name: "Bird Songs",
		type: AUDIO_TYPE.TRACK,
		isPremium: false,
		isLooping: true,
		description:
			"A dawn chorus of birdsong brings a breath of nature into your space—uplifting and grounding.",
		imageUrlStub: "https://images.coffitivity.com/bird-songs",
		albumId: "443950e8-634e-4406-ae2e-2b0d2d4c147f",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:relaxation", "effects:energy", "effects:productivity"],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:42+00",
	},
	{
		id: "8b964753-2930-42e9-b1db-8fb67a9bb200",
		audioUrlStub: "https://audios.coffitivity.com/creek",
		slug: "creek",
		name: "Creek",
		type: AUDIO_TYPE.TRACK,
		isPremium: false,
		isLooping: true,
		description:
			"A gentle, winding creek bubbles softly—ideal for calm focus and casual daydreaming.",
		imageUrlStub: "https://images.coffitivity.com/creek",
		albumId: "443950e8-634e-4406-ae2e-2b0d2d4c147f",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: [
			"effects:relaxation",
			"effects:sleep",
			"effects:sleep",
			"effects:meditation",
		],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:43+00",
	},
	{
		id: "7b14070c-ebdb-4ed1-8402-1817186f9aff",
		audioUrlStub: "https://audios.coffitivity.com/river",
		slug: "river",
		name: "River",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		isLooping: true,
		description:
			"The steady current of a flowing river brings a tranquil soundtrack to your thoughts.",
		imageUrlStub: "https://images.coffitivity.com/river",
		albumId: "443950e8-634e-4406-ae2e-2b0d2d4c147f",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: [
			"effects:relaxation",
			"effects:sleep",
			"effects:sleep",
			"effects:meditation",
		],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:44+00",
	},
	{
		id: "fcf94f1a-6792-407e-ac99-97b33313d536",
		audioUrlStub: "https://audios.coffitivity.com/airplane-cabin",
		slug: "airplane-cabin",
		name: "Airplane Cabin",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		isLooping: true,
		description:
			"A steady, low-frequency hum simulates in-flight ambiance—a travel-ready sound that promotes concentration.",
		imageUrlStub: "https://images.coffitivity.com/airplane-cabin",
		albumId: "c328dc9a-73aa-425d-947d-37df3a5e68f7",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:focus", "effects:sleep", "effects:productivity"],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:45+00",
	},
	{
		id: "9bbfd555-6217-4ebe-9acb-f402a5c2b78c",
		audioUrlStub: "https://audios.coffitivity.com/electric-train-car",
		slug: "electric-train-car",
		name: "Electric Train Car",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		isLooping: true,
		description:
			"The smooth hum and light clatter of a modern train—ideal for focus and motion-minded calm.",
		imageUrlStub: "https://images.coffitivity.com/electric-train-car",
		albumId: "c328dc9a-73aa-425d-947d-37df3a5e68f7",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:focus", "effects:creativity"],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:46+00",
	},
	{
		id: "a864329a-871a-4775-90b6-d89c962b3455",
		audioUrlStub: "https://audios.coffitivity.com/subway-car",
		slug: "subway-car",
		name: "Subway Car",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		isLooping: true,
		description:
			"Underground rail sounds in motion—gritty, urban, and full of subtle energy.",
		imageUrlStub: "https://images.coffitivity.com/subway-car",
		albumId: "c328dc9a-73aa-425d-947d-37df3a5e68f7",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:focus", "effects:creativity"],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:47+00",
	},
	{
		id: "1bf4c0bd-b6fa-4bdf-8cbd-a5035d80f510",
		audioUrlStub: "https://audios.coffitivity.com/car-cabin",
		slug: "car-cabin",
		name: "Car Cabin",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		isLooping: true,
		description:
			"The subtle hum of highway travel—perfect for working on the go or simulating mobile momentum.",
		imageUrlStub: "https://images.coffitivity.com/car-cabin",
		albumId: "c328dc9a-73aa-425d-947d-37df3a5e68f7",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:focus", "effects:creativity"],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:48+00",
	},
	{
		id: "b470c28d-5cf2-471f-90e1-8089615ea952",
		audioUrlStub: "https://audios.coffitivity.com/ocean-beach",
		slug: "ocean-beach",
		name: "Ocean Beach",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		isLooping: true,
		description:
			"Waves rolling ashore, seagulls in the distance—sun-soaked calm, no sunscreen required.",
		imageUrlStub: "https://images.coffitivity.com/ocean-beach",
		albumId: "443950e8-634e-4406-ae2e-2b0d2d4c147f",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:relaxation", "effects:creativity", "effects:sleep"],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:49+00",
	},
	{
		id: "181df085-0998-4eff-95eb-a0fe07f20b5c",
		audioUrlStub: "https://audios.coffitivity.com/jungle",
		slug: "jungle",
		name: "Jungle",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		isLooping: true,
		description:
			"Lush, layered wildlife calls and rustling greenery immerse you in a world of wild focus.",
		imageUrlStub: "https://images.coffitivity.com/jungle",
		albumId: "443950e8-634e-4406-ae2e-2b0d2d4c147f",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:stimulation", "effects:energy", "effects:creativity"],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:50+00",
	},
	{
		id: "9cc4d68d-24ab-4a5f-b1fa-a7d567a4dc2a",
		audioUrlStub: "https://audios.coffitivity.com/heavy-wind",
		slug: "heavy-wind",
		name: "Heavy Wind",
		type: AUDIO_TYPE.TRACK,
		isPremium: false,
		isLooping: true,
		description:
			"Gusty, dynamic, and atmospheric—ideal for immersive sound play or dramatic mental landscapes.",
		imageUrlStub: "https://images.coffitivity.com/heavy-wind",
		albumId: "443950e8-634e-4406-ae2e-2b0d2d4c147f",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:mindfulness", "effects:meditation"],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:51+00",
	},
	{
		id: "98d34f56-dd50-4ace-8cf6-1cc5b98761e5",
		audioUrlStub: "https://audios.coffitivity.com/cicadas",
		slug: "cicadas",
		name: "Cicadas",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		isLooping: true,
		description:
			"The hypnotic hum of high summer fills your ears, bringing warmth and stillness.",
		imageUrlStub: "https://images.coffitivity.com/cicadas",
		albumId: "443950e8-634e-4406-ae2e-2b0d2d4c147f",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:relaxation", "effects:sleep"],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:52+00",
	},
	{
		id: "fb9c62e8-4137-4e82-acc5-00cfa7341c7c",
		audioUrlStub: "https://audios.coffitivity.com/wetlands",
		slug: "wetlands",
		name: "Wetlands",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		isLooping: true,
		description:
			"Frogs, crickets, and gentle water movements create a rich, living texture for calm and concentration.",
		imageUrlStub: "https://images.coffitivity.com/wetlands",
		albumId: "443950e8-634e-4406-ae2e-2b0d2d4c147f",
		location: null,
		userId: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:relaxation", "effects:sleep"],
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:29:53+00",
	},
	{
		id: "53ef8040-7dad-4574-9df9-c9637ac874de",
		type: AUDIO_TYPE.TRACK,
		name: "Roaming Rome",
		slug: "roaming-rome",
		description:
			"Take a sonic stroll through the timeless streets of Rome. This recording captures the vibrant pulse of the Eternal City passing murmuring fountains, the grandeur of the Pantheon, the lively charm of Piazza Navona, and the echoing footsteps near Saint Ignazio and the Basilica of Saint Mary. Let the blend of voices, footsteps, and historic ambiance transport you to a day beneath Rome's golden light.",
		isPremium: true,
		isLooping: true,
		userId: null,
		location: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:creativity", "effects:stimulation", "effects:focus"],
		audioUrlStub: "https://audios.coffitivity.com/roaming-rome",
		imageUrlStub: "https://images.coffitivity.com/roaming-rome",
		albumId: "194205c6-9587-48dc-8566-deb5c24cb5e3",
		createdAt: "2025-08-01 20:47:35.29594+00",
		updatedAt: "2025-08-01 20:47:35.29594+00",
		releaseDate: "2025-08-01 10:00:00+00",
	},
	{
		id: "5ae79d56-e4e6-4d52-b2e5-278a902cca6e",
		type: AUDIO_TYPE.TRACK,
		name: "Hawker Harmony",
		slug: "hawker-harmony",
		description:
			"The heartbeat of Singapore's daily life. An indoor hawker center alive with the pulse of breakfast chatter, clattering dishes, playful bargaining, and the steam of freshly pulled kopi drifting through the air.",
		isPremium: true,
		isLooping: true,
		userId: null,
		location: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:creativity", "effects:stimulation", "effects:focus"],
		audioUrlStub: "https://audios.coffitivity.com/hawker-harmony",
		imageUrlStub: "https://images.coffitivity.com/hawker-harmony",
		albumId: "26b9fadb-fd90-4200-98f7-46db2a9c4fb2",
		createdAt: "2025-10-06 20:29:15.228642+00",
		updatedAt: "2025-10-06 20:29:15.228642+00",
		releaseDate: "2025-10-06 10:00:00+00",
	},
	{
		id: "cd1030d2-6270-426b-bfa5-cdba0cae611d",
		type: AUDIO_TYPE.TRACK,
		name: "Dolac Daybreak",
		slug: "dolac-daybreak",
		description:
			"Begin your day among the shaded stalls of Dolac Market, where paper bags crinkle, birds sing overhead, and the perfume of fresh produce carries on the footsteps of a city in motion.",
		isPremium: true,
		isLooping: true,
		userId: null,
		location: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:creativity", "effects:stimulation", "effects:focus"],
		audioUrlStub: "https://audios.coffitivity.com/dolac-daybreak",
		imageUrlStub: "https://images.coffitivity.com/dolac-daybreak",
		albumId: "26b9fadb-fd90-4200-98f7-46db2a9c4fb2",
		createdAt: "2025-10-06 20:29:15.228642+00",
		updatedAt: "2025-10-06 20:29:15.228642+00",
		releaseDate: "2025-10-06 10:00:00+00",
	},
	{
		id: "1eb4d579-0359-4516-96b0-2e10a09bf564",
		type: AUDIO_TYPE.TRACK,
		name: "Cypriot Chatter",
		slug: "cypriot-chatter",
		description:
			"A sunlit morning under the olive trees. Cars pass along cobbled lanes as voices in Greek blend with bird song, clinking cutlery, and the warm chatter of a coastal crowd drawn to fresh flavors and conversation.",
		isPremium: true,
		isLooping: true,
		userId: null,
		location: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:creativity", "effects:stimulation", "effects:focus"],
		audioUrlStub: "https://audios.coffitivity.com/cypriot-chatter",
		imageUrlStub: "https://images.coffitivity.com/cypriot-chatter",
		albumId: "26b9fadb-fd90-4200-98f7-46db2a9c4fb2",
		createdAt: "2025-10-06 20:29:15.228642+00",
		updatedAt: "2025-10-06 20:29:15.228642+00",
		releaseDate: "2025-10-06 10:00:00+00",
	},
	{
		id: "66b12c8d-a6a7-461d-8936-22814d7edb42",
		type: AUDIO_TYPE.TRACK,
		name: "Penang Street Fest",
		slug: "penang-street-fest",
		description:
			"Step into a sea of flavor and festivity. Open-air stalls sizzle, voices rise and fall, and motorbikes hum behind the chime of plates and the thrill of open kitchens serving the soul of Penang.",
		isPremium: true,
		isLooping: true,
		userId: null,
		location: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:creativity", "effects:stimulation", "effects:focus"],
		audioUrlStub: "https://audios.coffitivity.com/penang-street-fest",
		imageUrlStub: "https://images.coffitivity.com/penang-street-fest",
		albumId: "26b9fadb-fd90-4200-98f7-46db2a9c4fb2",
		createdAt: "2025-10-06 20:29:15.228642+00",
		updatedAt: "2025-10-06 20:29:15.228642+00",
		releaseDate: "2025-10-06 10:00:00+00",
	},
	{
		id: "42efe92d-5d8f-4a9c-a2c3-b8377cc56aaf",
		type: AUDIO_TYPE.TRACK,
		name: "Dong Xuan Drift",
		slug: "dong-xuan-drift",
		description:
			"Wander through the soft bustle of Hanoi's Dong Xuan Market, where murmured conversations, delicate footsteps, and the rustle of trade echo under its towering roof. A moment of motion and stillness all in one.",
		isPremium: true,
		isLooping: true,
		userId: null,
		location: null,
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:creativity", "effects:stimulation", "effects:focus"],
		audioUrlStub: "https://audios.coffitivity.com/dong-xuan-drift",
		imageUrlStub: "https://images.coffitivity.com/dong-xuan-drift",
		albumId: "26b9fadb-fd90-4200-98f7-46db2a9c4fb2",
		createdAt: "2025-10-06 20:29:15.228642+00",
		updatedAt: "2025-10-06 20:29:15.228642+00",
		releaseDate: "2025-10-06 10:00:00+00",
	},
	{
		id: "f0e7d99e-590e-4cdf-899a-18434883316e",
		type: AUDIO_TYPE.TRACK,
		name: "Tuesday at Tarihi",
		slug: "tuesday-at-tarihi",
		description:
			"Lose yourself in the timeless bustle of Istanbul's Kadiköy District, where spirited vendors, weaving cars, and century-old market rhythms create a layered soundscape full of tradition and movement.",
		isPremium: true,
		isLooping: true,
		userId: null,
		location: null,
		albumId: "26b9fadb-fd90-4200-98f7-46db2a9c4fb2",
		blend: null,
		collectionId: COLLECTION_IDS.SOUNDSCAPE,
		effectIds: ["effects:creativity", "effects:stimulation", "effects:focus"],
		audioUrlStub: "https://audios.coffitivity.com/tuesday-at-tarihi",
		imageUrlStub: "https://images.coffitivity.com/tuesday-at-tarihi",
		createdAt: "2025-10-06 20:29:15.228642+00",
		updatedAt: "2025-10-06 20:29:15.228642+00",
		releaseDate: "2025-10-06 10:00:00+00",
	},
];
